module.exports = __webpack_public_path__ + "img/application_bg5_m.497f48cb.jpg";